const KEY = "brushup_stats_v1";

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}

export function getGlobalStats() {
  const all = readAll();
  return all.__global || {
    played: 0,
    wins: 0,
    currentStreak: 0,
    maxStreak: 0,
    distribution: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0 },
  };
}

export function getPuzzleState(puzzleId) {
  const all = readAll();
  return all[puzzleId] || null;
}

export function savePuzzleState(puzzleId, state) {
  const all = readAll();
  all[puzzleId] = state;
  writeAll(all);
}

export function recordResult(puzzleId, { won, guessesUsed }) {
  const all = readAll();
  // Prevent double-counting if we already recorded final for this puzzle
  if (all[puzzleId]?.recorded) return;
  const g = all.__global || getGlobalStats();
  g.played += 1;
  if (won) {
    g.wins += 1;
    g.currentStreak += 1;
    g.maxStreak = Math.max(g.maxStreak, g.currentStreak);
    g.distribution[guessesUsed] = (g.distribution[guessesUsed] || 0) + 1;
  } else {
    g.currentStreak = 0;
  }
  all.__global = g;
  all[puzzleId] = { ...(all[puzzleId] || {}), recorded: true };
  writeAll(all);
}
